import { ClickableSmallCardsSet } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { Card } from 'app/blocks/sections/ClickableSmallCardsSet/cards'

export interface IAttributes extends React.ComponentProps<typeof ClickableSmallCardsSet> {
  cards: Card[]
}

const ClickableSmallCardsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <ClickableSmallCardsSet
      title={attributes.title}
      subtitle={attributes.subtitle}
      background={attributes?.background ?? 'white'}
      cards={attributes?.cards.map(({ text, url, linkToExternal, className, iconUrl }) => ({
        text,
        url,
        target: linkToExternal ? '_blank' : '_self',
        icon: <LazyLoadImage src={iconUrl} width="100%" height="100%" alt={text} style={{ objectFit: 'contain' }} />,
        className,
      }))}
    />
  )
}

export default ClickableSmallCardsBlock
